/**
 * Pathless layout route — guard de autenticação.
 *
 * Todas as rotas filhas (`_auth.*.tsx`) só renderizam se o usuário estiver
 * autenticado. Caso contrário, redireciona pra /login?next=<rota original>.
 *
 * Lê `useAuthStore.getState()` em `beforeLoad` — síncrono, sem hook (rotas
 * são avaliadas fora do React render). O store é inicializado em
 * `main.tsx` ANTES do RouterProvider, então `status === 'initializing'`
 * é impossível aqui (cuidamos no main).
 */

import { AppShell } from '@/components/layout/AppShell';
import { useAuthStore } from '@/lib/auth-store';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ location }) => {
    const status = useAuthStore.getState().status;
    if (status !== 'authenticated') {
      throw redirect({
        to: '/login',
        search: { next: location.href },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
